import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';

interface AddGroupModalProps {
  onCancel: () => void;
  onSave: (groupName: string) => void;
}

const AddGroupModal: React.FC<AddGroupModalProps> = ({ onCancel, onSave }) => {
  const [groupName, setGroupName] = useState('');

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, []);

  const handleSave = () => {
    if (groupName.trim() === '') return;
    onSave(groupName.trim());
  };

  return (
    <div className="fixed inset-0 z-50 bg-black/80 backdrop-blur-sm overflow-y-auto py-10 px-4">
      <div className="max-w-md mx-auto bg-neutral-900 rounded-lg shadow-lg border border-neutral-800">
        {/* Header */}
        <div className="flex justify-between items-center px-6 py-4 border-b border-neutral-800">
          <h2 className="text-white font-semibold text-lg">Add Agent Group</h2>
          <button onClick={onCancel} className="text-gray-400 hover:text-white">
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Form */}
        <div className="p-6 space-y-4 text-sm text-white">
          <div>
            <label className="text-gray-400 block mb-1">Group Name</label>
            <input
              value={groupName}
              onChange={(e) => setGroupName(e.target.value)}
              className="w-full bg-neutral-800 px-3 py-2 rounded outline-none"
              placeholder="Enter group name"
            />
          </div>
        </div>


        {/* Footer */}
        <div className="flex justify-end gap-3 px-6 py-4 border-t border-neutral-800 bg-neutral-950">
          <button onClick={onCancel} className="text-gray-400 hover:text-white text-sm">
            Cancel
          </button>
          <button
            onClick={handleSave}
            className="bg-indigo-600 hover:bg-indigo-700 text-white px-5 py-2 rounded-md text-sm shadow"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddGroupModal;
